<template>
    <main class="mt-3">
       

        <!-- Secciones del Formulario -->
        <div 
            class="card mb-2 shadow-none border-left-lg" 
            v-for="(item, index) in $v.formulario.$each.$iter" 
            :key="item.id"
            :class="getSectionBorderClass(item.$model.nombre)"
        >
            <div class="card-header bg-white py-3 d-flex align-items-center justify-content-between">
                <div class="text-gray-700 font-weight-bold mb-0 text-uppercase small tracking-wider">
                    <i class="fas fa-clipboard-check mr-2 text-primary"></i>
                    {{ item.$model.nombre }}
                </div>
                <span class="badge badge-light border text-muted small" v-if="isSeccionRiesgo(item.$model.nombre)">
                    <i class="fas fa-robot mr-1 text-primary"></i> Cálculo Automático
                </span>
            </div>
            <div class="card-body bg-light">
                <div class="row">
                    <div 
                        class="col-12 mb-2" 
                        v-for="(pregunta, pIndex) in item.$model.preguntas" 
                        :key="`pregunta_${index}_${pIndex}`"
                    >
                        <!-- Tarjeta de pregunta normal o pregunta RIESGO destacada -->
                        <div 
                            class="card border-0 shadow-none bg-white p-2 rounded shadow-sm h-100"
                            :class="{ 'border-primary border-left-lg': isPreguntaRiesgo(pregunta.nombre) }"
                        >
                            <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                                <div class="font-weight-bold text-gray-700 mb-2 mb-md-0 mr-3">
                                    <span class="mr-2">{{ pIndex + 1 }}.</span>
                                    {{ pregunta.nombre }}
                                    <span v-if="isPreguntaRiesgo(pregunta.nombre)" class="badge badge-primary-soft text-primary ml-2 font-weight-normal small">
                                        <i class="fas fa-magic mr-1"></i> Se marca según los criterios seleccionados
                                    </span>
                                </div>
                                <div class="d-flex flex-wrap align-items-center">
                                    <div 
                                        class="custom-control custom-radio custom-control-inline mr-3"
                                        v-for="(opcion, oIndex) in pregunta.opciones"
                                        :key="`opcion_${index}_${pIndex}_${oIndex}`"
                                    >
                                        <input 
                                            type="radio" 
                                            :id="`radio_${index}_${pIndex}_${oIndex}`" 
                                            :name="`radio_group_${index}_${pIndex}`"
                                            class="custom-control-input"
                                            :value="opcion.texto"
                                            v-model="pregunta.respuesta"
                                            @change="onOpcionChange"
                                            :disabled="isPreguntaRiesgo(pregunta.nombre)"
                                        />
                                        <label 
                                            class="custom-control-label font-weight-500 cursor-pointer"
                                            :class="getOptionLabelClass(opcion.texto, pregunta.respuesta)"
                                            :for="`radio_${index}_${pIndex}_${oIndex}`"
                                        >
                                            {{ opcion.texto }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div 
                                class="text-danger x-small mt-1" 
                                v-if="item.preguntas.$each[pIndex].respuesta.$error && item.preguntas.$each[pIndex].respuesta.$dirty"
                            >
                                <i class="fas fa-exclamation-circle mr-1"></i> Este campo es obligatorio
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Banner de Clasificación de Riesgo -->
        <div v-if="clasificacion" class="mb-3">
            <div class="card shadow-none bg-white border-left-lg" :class="clasificacion.borderClass">
                <div class="card-body py-2 px-3">
                    <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                        <div class="d-flex align-items-center mb-1 mb-md-0">
                            <i :class="[clasificacion.icon, 'mr-2']" style="font-size: 1.15rem;"></i>
                            <span class="font-weight-bold mr-2 text-dark" style="font-size: 0.9rem;">
                                {{ clasificacion.titulo }}
                            </span>
                            <span class="badge px-2 py-1 font-weight-bold" :class="clasificacion.badgeClass" style="font-size: 0.72rem;">
                                {{ clasificacion.valorRiesgo }}
                            </span>
                        </div>
                        <div class="d-flex align-items-center" v-if="clasificacion.indicaAsa">
                            <span class="badge badge-light border text-danger font-weight-bold px-2 py-1" style="font-size: 0.72rem;">
                                <i class="fas fa-pills mr-1"></i> Toma de ASA Indicada
                            </span>
                        </div>
                    </div>
                    <div class="text-muted small mt-1 pl-md-4" style="font-size: 0.8rem; line-height: 1.35;">
                        {{ clasificacion.descripcion }}
                    </div>
                </div>
            </div>
        </div>

        <div class="alert alert-danger-soft border-left-lg border-danger text-danger text-center small py-3 mb-4" v-if="$v.formulario.$error && $v.formulario.$dirty">
            <i class="fas fa-exclamation-triangle mr-2"></i> Por favor, complete todos los campos obligatorios del formulario antes de continuar.
        </div>

    </main>
</template>

<script>
import formulariosService from "../../../services/formulariosService";
import Toast from "../../../components/common/utilities/toast";
import respuestasFormulariosService from "../../../services/respuestasFormulariosService";
import { isEmpty } from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
    name: "formularioPreeclampsia",
    props: ["idHistoria", "finalizada", "codigo", "trimestre", "usuario", "idUsuario"],
    data() {
        return {
            formulario: [],
            id_formulario: "",
        };
    },
    validations() {
        return {
            formulario: {
                $each: {
                    preguntas: {
                        $each: {
                            respuesta: { required }
                        }
                    }
                }
            }
        };
    },
    computed: {
        clasificacion() {
            if (!Array.isArray(this.formulario) || this.formulario.length === 0) return null;

            const conteo = this.contarCriterios();
            const esAlto = conteo.totalAlto >= 1;
            const esModerado = conteo.totalAlto === 0 && conteo.totalMod >= 1;

            if (esAlto) {
                return {
                    valorRiesgo: "ALTO",
                    titulo: "Alto Riesgo de Preeclampsia",
                    descripcion: `Cumple ${conteo.totalAlto} criterio(s) de la sección de alto riesgo. Se indica tomar Ácido Acetilsalicílico (ASA) antes de la semana 16 hasta el parto.`,
                    indicaAsa: true,
                    borderClass: "border-left-danger",
                    badgeClass: "badge-danger",
                    icon: "fas fa-exclamation-triangle text-danger"
                };
            }

            if (esModerado) {
                const indicaAsa = conteo.totalMod >= 2;
                const descripcion = indicaAsa
                    ? `Cumple ${conteo.totalMod} criterios de riesgo moderado (≥ 2 factores). Se indica tomar Ácido Acetilsalicílico (ASA) antes de la semana 16 hasta el parto.`
                    : `Cumple 1 criterio de riesgo moderado. Se requieren 2 o más factores para indicar tomar ASA. Realizar vigilancia y control prenatal estricto de la presión arterial.`;

                return {
                    valorRiesgo: "MODERADO",
                    titulo: "Riesgo Moderado de Preeclampsia",
                    descripcion: descripcion,
                    indicaAsa: indicaAsa,
                    borderClass: "border-left-warning",
                    badgeClass: "badge-warning text-dark",
                    icon: "fas fa-info-circle text-warning"
                };
            }

            return {
                valorRiesgo: "BAJO",
                titulo: "Bajo Riesgo de Preeclampsia",
                descripcion: "No cumple criterios de alto riesgo ni de riesgo moderado. Continuar control prenatal habitual.",
                indicaAsa: false,
                borderClass: "border-left-success",
                badgeClass: "badge-success",
                icon: "fas fa-check-circle text-success"
            };
        }
    },
    methods: {
        isPreguntaRiesgo(nombre) {
            return nombre && String(nombre).trim().toUpperCase() === "RIESGO";
        },
        isSeccionRiesgo(nombre) {
            if (!nombre) return false;
            const upper = String(nombre).trim().toUpperCase();
            return upper.includes("RIESGO DE PREECLAMPSIA") && !upper.includes("ALTO") && !upper.includes("MODERADO");
        },
        getSectionBorderClass(nombre) {
            if (!nombre) return "";
            const upper = String(nombre).trim().toUpperCase();
            if (upper.includes("ALTO")) return "border-left-danger";
            if (upper.includes("MODERADO")) return "border-left-warning";
            return "border-left-primary";
        },
        getOptionLabelClass(textoOpcion, respuestaSeleccionada) {
            const isSelected = textoOpcion === respuestaSeleccionada;
            const upper = String(textoOpcion).trim().toUpperCase();
            if (isSelected) {
                if (upper === "SI" || upper === "ALTO") return "text-danger font-weight-bold";
                if (upper === "MODERADO") return "text-warning font-weight-bold";
                if (upper === "NO" || upper === "BAJO") return "text-success font-weight-bold";
                return "text-primary font-weight-bold";
            }
            return "text-dark";
        },
        esAfirmativo(val) {
            if (!val) return false;
            const str = String(val).trim().toUpperCase();
            return str === "SI" || str === "SÍ" || str === "1" || str === "TRUE";
        },
        contarCriterios() {
            let totalAlto = 0;
            let totalMod = 0;

            if (!Array.isArray(this.formulario)) {
                return { totalAlto, totalMod };
            }

            this.formulario.forEach(sec => {
                const secNombre = (sec.nombre || "").toUpperCase();
                const esSecAlto = secNombre.includes("ALTO");
                const esSecMod = secNombre.includes("MODERADO");

                if (!esSecAlto && !esSecMod) return;

                (sec.preguntas || []).forEach(preg => {
                    if (this.isPreguntaRiesgo(preg.nombre)) return;

                    if (this.esAfirmativo(preg.respuesta)) {
                        if (esSecAlto) totalAlto++;
                        else if (esSecMod) totalMod++;
                    }
                });
            });

            return { totalAlto, totalMod };
        },
        calcularRiesgo() {
            if (!Array.isArray(this.formulario) || !this.formulario.length) return;

            const conteo = this.contarCriterios();
            let nuevoValor = "BAJO";

            if (conteo.totalAlto >= 1) {
                nuevoValor = "ALTO";
            } else if (conteo.totalMod >= 1) {
                nuevoValor = "MODERADO";
            } else {
                nuevoValor = "BAJO";
            }

            for (const seccion of this.formulario) {
                const preguntaRiesgo = (seccion.preguntas || []).find(p => this.isPreguntaRiesgo(p.nombre));
                if (preguntaRiesgo) {
                    const opcionCoincidente = (preguntaRiesgo.opciones || []).find(opc => 
                        String(opc.texto).trim().toUpperCase() === nuevoValor
                    );
                    preguntaRiesgo.respuesta = opcionCoincidente ? opcionCoincidente.texto : nuevoValor;
                    break;
                }
            }
        },
        onOpcionChange() {
            this.calcularRiesgo();
        },
        async cargarFormulario() {
            try {
                this.LoaderSpinnerShow();

                const codigoFormulario = this.codigo || "PRECLAM";
                const response = await formulariosService.showByCode(codigoFormulario);
                this.id_formulario = response.data.id;

                const params = {
                    id: this.idHistoria,
                    id_formulario: this.id_formulario,
                };
                if (this.trimestre) {
                    params.trimestre = this.trimestre;
                }

                let respuestas_formulario = await respuestasFormulariosService.showByRespuestableId(params);

                const userId = (this.usuario && typeof this.usuario === "object" ? this.usuario.id : this.usuario) || this.idUsuario;

                const tieneRespuestasId = Boolean(
                    respuestas_formulario &&
                    respuestas_formulario.data &&
                    !isEmpty(respuestas_formulario.data) &&
                    respuestas_formulario.data.items &&
                    respuestas_formulario.data.items.length > 0
                );

                if (!tieneRespuestasId && userId) {
                    const last_response = await respuestasFormulariosService.showLastByUser({
                        id_usuario: userId,
                        id_formulario: this.id_formulario,
                        codigo_tipo_historia: "EMB",
                        id_historia: this.idHistoria,
                    });

                    if (last_response && last_response.data && !isEmpty(last_response.data) && last_response.data.items && last_response.data.items.length > 0) {
                        respuestas_formulario = last_response;
                    }
                }

                const tieneRespuestas = Boolean(
                    respuestas_formulario &&
                    respuestas_formulario.data &&
                    respuestas_formulario.data.items &&
                    Array.isArray(respuestas_formulario.data.items) &&
                    respuestas_formulario.data.items.length > 0
                );

                this.formulario = response.data.secciones.map(x => {
                    return {
                        id: x.id,
                        nombre: x.nombre,
                        preguntas: x.preguntas.map(y => {
                            let respuesta = "";
                            if (tieneRespuestas) {
                                const itemEncontrado = respuestas_formulario.data.items.find(r => Number(r.id_pregunta) === Number(y.id));
                                respuesta = (itemEncontrado && itemEncontrado.valor !== null && itemEncontrado.valor !== undefined)
                                    ? itemEncontrado.valor
                                    : (y.defaultValue || "");
                            } else {
                                respuesta = y.defaultValue || "";
                            }

                            const tipoMap = {
                                "TEXTO": "TEXT",
                                "OPCIONES": "OPC",
                                "FECHA": "DATE",
                                "NUMERO": "NUM"
                            };

                            return {
                                id: y.id,
                                id_seccion: y.id_seccion,
                                nombre: y.nombre,
                                opciones: y.opciones,
                                tipo: tipoMap[y.tipo] || "",
                                respuesta: respuesta,
                            };
                        })
                    };
                });

                // Auto-marcar la pregunta RIESGO con base en los datos cargados
                this.calcularRiesgo();

                this.LoaderSpinnerHide();
            } catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: "error",
                    title: "Ocurrió un error al cargar el formulario de preeclampsia"
                });
            }
        },
        async save() {
            try {
                // Asegurar cálculo actualizado antes de guardar
                this.calcularRiesgo();

                this.$v.$touch();
                if (this.$v.$invalid) return;

                let respuestas = [];

                this.formulario.forEach(x => {
                    let respuestas_secciones = x.preguntas.map(y => {
                        let opcion = (y.opciones || []).find(opc => opc.texto === y.respuesta);
                        return {
                            id_pregunta: y.id,
                            respuesta: y.respuesta,
                            id_opcion: opcion !== undefined ? opcion.id : "",
                        };
                    });

                    respuestas.push(...respuestas_secciones);
                });

                let respuestas_historia = {
                    id_historia: this.idHistoria,
                    id_formulario: this.id_formulario,
                    respuestas: respuestas,
                };

                if (this.trimestre) {
                    respuestas_historia.trimestre = this.trimestre;
                }

                this.LoaderSpinnerShow();
                await respuestasFormulariosService.store(respuestas_historia);
                this.LoaderSpinnerHide();

                Toast.fire({
                    icon: "success",
                    title: "Riesgo de preeclampsia guardado con éxito"
                });
            } catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: "error",
                    title: "Ocurrió un error al procesar la solicitud"
                });
            }
        },
    },
    async created() {
        await this.cargarFormulario();
    },
    watch: {
        idHistoria: async function (value) {
            if (value) {
                await this.cargarFormulario();
            }
        },
        trimestre: async function (value) {
            if (value) {
                await this.cargarFormulario();
            }
        },
        codigo: async function (value) {
            if (value) {
                await this.cargarFormulario();
            }
        }
    },
};
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
